import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=1da1e1d0&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.scss?vue&type=style&index=0&id=1da1e1d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1e1d0",
  null
  
)

export default component.exports